<template>
      <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light" v-animate-css="'slideInDown'">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#"><i class="fas fa-bars"></i></a>
      </li>
    </ul>

    <!-- SEARCH FORM -->

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- The redesigned management app; both stay available until it becomes the default -->
      <li class="nav-item d-flex align-items-center">
        <a class="btn btn-sm btn-primary new-look" :href="newLookUrl" title="Open the redesigned management">
          <i class="fas fa-magic mr-1"></i> New Look
        </a>
      </li>
      <!-- Messages Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-comments"></i>
          <!--
          <span class="badge badge-danger navbar-badge">0</span>
          -->
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>
        </div>
      </li>
      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <!--
          <span class="badge badge-warning navbar-badge">0</span>
          -->
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">0 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-envelope mr-2"></i> 0 new messages
            <span class="float-right text-muted text-sm"></span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
        </div>
      </li>

      <!-- Theme toggle -->
      <li class="nav-item d-flex align-items-center">
        <a class="nav-link" href="#" @click.prevent="onToggleDark" :title="isDark ? 'Switch to light' : 'Switch to dark'">
          <i v-if="isDark" class="fas fa-sun"></i>
          <i v-else class="fas fa-moon"></i>
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#"> <span class="alert alert-primary btn-xs"> {{ user.role | capitalizeAndReplace }} </span></a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      newLookUrl: process.env.VUE_APP_NEW_LOOK_URL || 'https://management-next.adcrew.co',
    }
  },
  methods: {
    toggleDark() {
      this.isDark = !this.isDark;
      try { localStorage.setItem('dark-mode', this.isDark) } catch (e) {}
      if (typeof this.$setDarkMode === 'function') {
        this.$setDarkMode(this.isDark)
      } else {
        if (this.isDark) document.body.classList.add('dark-mode')
        else document.body.classList.remove('dark-mode')
      }
    },
    onToggleDark() {
      this.toggleDark()
    }
  }

}
</script>

<style scoped>
.new-look { margin-right: 8px; font-weight: 600; white-space: nowrap; }
</style>